export const TAB_TYPES = {
  ACCOUNTS: 'ACCOUNTS',
  CONTACTS: 'CONTACTS',
};

export const TAB_TYPES_ARRAY = [TAB_TYPES.ACCOUNTS, TAB_TYPES.CONTACTS];

export const SORT_BOTH = ['ascending', 'descending'];

export const PAGE_SIZE = 10;
